// src/utils/reports.js

const informesDisponibles = [
  {
    id: 'report-comparativa-mensual-totales',
    label: 'Comparativa mensual totales',
    keys: ['movimientos', 'categorias', 'presupuestos']
  }
  // Más informes se pueden añadir aquí
  // {
  //   id: 'otro-informe',
  //   label: 'Otro Informe',
  //   keys: ['movimientos']
  // }
];

export default informesDisponibles;
